export default __webpack_public_path__ + "static/media/346.270aee2b.gif";